import React, { useRef } from "react";
import styled from "styled-components";
import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const TestimonialsSection = styled.div`
  padding-top: 7rem;
  padding-left: 8rem;
  padding-right: 8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const SmallHeader = styled.h3`
  color: #1890ff;
  text-align: left;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
`;

const BigHeader = styled.h2`
  text-align: left;
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 100%;
`;

const TestimonialsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 1.5rem;
  padding-bottom: 1rem;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const TestimonialCard = styled.div`
  min-width: 280px;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const TestimonyText = styled.p`
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
`;

const TestimonyName = styled.p`
  color: #1890ff;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

const NavigationButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
`;

const NavButton = styled(Button)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border: 1px solid #d9d9d9;

  &:hover {
    background: #e0e0e0;
  }
`;

const testimonials = [
  {
    text: "The experience was amazing! The tour guides were knowledgeable and made our trip memorable. Will definitely recommend to friends.",
    name: "Adebayo Johnson",
  },
  {
    text: "Excellent service from start to finish. The accommodations were perfect and the activities were well organized. Can't wait to book again!",
    name: "Chioma Okeke",
  },
  {
    text: "I've traveled with many companies, but this was by far the best experience. Attention to detail was exceptional.",
    name: "Emeka Nwankwo",
  },
  {
    text: "Our family had the most wonderful vacation thanks to this company. The kids are already asking when we can go back!",
    name: "Funke Adeleke",
  },
  {
    text: "Professional and reliable. They handled everything perfectly, even when we had last minute changes to our itinerary.",
    name: "Oluwaseun Bello",
  },
];

const Testimonials: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -300 : 300;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <TestimonialsSection>
      <SmallHeader>Testimonials</SmallHeader>
      <BigHeader>See what our customers have to say about us</BigHeader>

      <TestimonialsContainer ref={scrollRef}>
        {testimonials.map((testimonial, index) => (
          <TestimonialCard key={index}>
            <TestimonyText>{testimonial.text}</TestimonyText>
            <TestimonyName>{testimonial.name}</TestimonyName>
          </TestimonialCard>
        ))}
      </TestimonialsContainer>

      <NavigationButtons>
        <NavButton icon={<LeftOutlined />} onClick={() => scroll("left")} />
        <NavButton icon={<RightOutlined />} onClick={() => scroll("right")} />
      </NavigationButtons>
    </TestimonialsSection>
  );
};

export default Testimonials;
